import { AccountBalance, AccountBalanceWallet, AcUnit, Atm, CompareArrows, ConfirmationNumber, Contactless, CreditCard, Dvr, Group, Person, RotateLeft, TrendingDown } from "@material-ui/icons";
import React, { useEffect } from "react";

class AdminService {
  constructor() {
    var data = {};
    const data1 = localStorage.getItem("nx_cent");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    this.accountData = data;

    this.ORIGIN = process.env.REACT_APP_ORIGIN;
    this.BASE_URL = getMsUrl('ad');
    this.LOGIN = this.BASE_URL + "/api/v1/auth/login";
    this.GET_ALL_USERS = this.BASE_URL + "/api/v1/users";
    this.GET_USERS_BY_ORGANIZATION_ID =
      this.BASE_URL + "/api/v1/user/organization/";
      this.GET_USERS_BY_TYPE =
      this.BASE_URL + "/api/v1/user/type/";
    this.CREATE_USER = this.BASE_URL + "/api/v1/user/register";
    this.UPDATE_USER = this.BASE_URL + "/api/v1/user/";
    this.CHANGE_PASSWORD = this.BASE_URL + "/api/v1/user/changePassword";
    this.INITIATE_RESET_PASSWORD = this.BASE_URL + "/api/v1/auth/initiateResetPassword";
    this.CONFIRM_RESET_PASSWORD = this.BASE_URL + "/api/v1/auth/confirmResetPassword";
    this.GET_AGENT_ASSISTANTS = this.BASE_URL + "/api/v1/user/assistantAgent/";
    this.GET_USERS_BY_ORGANIZATION_AND_TYPE=this.BASE_URL+"/api/v1/user/organization/"
    this.GET_AGENTS_WITHOUT_MANAGER=this.BASE_URL+"/api/v1/user/agent-without-manager/organization/"
    this.GET_INDIVIDUAL_AGENTS =
      this.BASE_URL + "/api/v1/user/individualAgents";
    this.DEACTIVATE_USER = this.BASE_URL + "/api/v1/user/status/deactivate/";
    this.REACTIVATE_USER = this.BASE_URL + "/api/v1/user/status/reactivate/";
    this.SUSPEND_USER = this.BASE_URL + "/api/v1/user/status/suspend/";
    this.GET_ALL_ORGANIZATIONS = this.BASE_URL + "/api/v1/organizations";
    this.CREATE_ORGANIZATION = this.BASE_URL + "/api/v1/organization";
    this.GET_ORGANIZATION_BY_TYPE =
      this.BASE_URL + "/api/v1/organization/type/";
    this.REACTIVATE_ORGANIZATION =
      this.BASE_URL + "/api/v1/organization/status/reactivate/";
    this.DEACTIVATE_ORGANIZATION =
      this.BASE_URL + "/api/v1/organization/status/deactivate/";
    this.UPDATE_ORGANIZATION = this.BASE_URL + "/api/v1/organization/";
    this.GET_ORGANIZATION_BY_ID = this.BASE_URL + "/api/v1/organization/";
    this.UPLOAD_ORGANIZATION_LOGO=this.BASE_URL+"/api/v1/organization/upload-logo/"
    this.GET_ALL_ROLES = this.BASE_URL + "/api/v1/roles";
    this.CREATE_ROLE = this.BASE_URL + "/api/v1/role";
    this.UPDATE_ROLE = this.BASE_URL + "/api/v1/role/";
    this.DEACTIVATE_ROLE = this.BASE_URL + "/api/v1/role/status/deactivate/";
    this.REACTIVATE_ROLE = this.BASE_URL + "/api/v1/role/status/reactivate/";
    this.GET_ROLES_BY_ORGANIZATION =
      this.BASE_URL + "/api/v1/role/organization/";
    this.GET_PRIVILEGES_BY_ROLE =
      this.BASE_URL + "/api/v1/role-privilege/role/";
    this.GET_ALL_PRIVILEGES = this.BASE_URL + "/api/v1/privileges";
    this.UPDATE_PRIVILEGE = this.BASE_URL + "/api/v1/privilege/";
    this.ASSIGN_PRIVILEGE = this.BASE_URL + "/api/v1/role-privilege";
    this.REMOVE_ROLE_PRIVILEGE = this.BASE_URL + "/api/v1/role-privilege/";
    this.GET_ORGANIZATION_COMMISSIONS =
      this.BASE_URL + "/api/v1/organization-commissions";
    this.GET_ORGANIZATION_COMMISSION_BY_ORGANIZATION_ID =
      this.BASE_URL + "/api/v1/organization-commission/organization/";
    this.UPDATE_ORGANIZATION_COMMISSION =
      this.BASE_URL + "/api/v1/organization-commission/";
    this.DEACTIVATE_ORGANIZATION_COMMISSION =
      this.BASE_URL + "/api/v1/organization-commission/status/deactivate/";
    this.REACTIVATE_ORGANIZATION_COMMISSION =
      this.BASE_URL + "/api/v1/organization-commission/status/reactivate/";
    this.CREATE_ORGANIZATION_COMMISSION =
      this.BASE_URL + "/api/v1/organization-commission";
    this.GET_ALL_LICENSES = this.BASE_URL + "/api/v1/organization-licenses";
    this.CREATE_LICENSE = this.BASE_URL + "/api/v1/organization-license";
    this.UPDATE_LICENSE = this.BASE_URL + "/api/v1/organization-license/";
    this.GET_LICENSE_BY_ORGANIZATION_ID =
      this.BASE_URL + "/api/v1/organization-license/organization/";

    this.GET_SERVICE_DISCOVERY_LIST =
      this.BASE_URL + "/api/v1/service-discovery";
    this.GET_SERVICE_REGISTRIES = this.BASE_URL + "/api/v1/service-registry";
    this.DEACTIVATE_SERVICE_REGISTRY =
      this.BASE_URL + "/api/v1/service-registry/status/deactivate/";
    this.REACTIVATE_SERVICE_REGISTRY =
      this.BASE_URL + "/api/v1/service-registry/status/reactivate/";
    this.CREATE_NEW_REGISTRY =
      this.BASE_URL + "/api/v1/service-registry/external-system/register";
    this.UPDATE_REGISTRY_TOKEN =
      this.BASE_URL + "/api/v1/service-registry/external-system/update-token/";
    this.UPDATE_REGISTRY = this.BASE_URL + "/api/v1/service-registry/";

    this.BROADCAST_MESSAGE =
      this.BASE_URL + "/api/v1/organization/broadcast-messages";
    this.SEND_MESSAGE = this.BASE_URL + "/api/v1/organization/send-message";

    this.GET_USERS_ASSIGNED_TO_OPERATOR =this.BASE_URL+"/api/v1/user-allowed-operator/"
    this.GET_USER_ALLOWED_OPERATORS=this.BASE_URL+"/api/v1/user-allowed-operator/user/"
    this.REMOVE_ONE_USER_ALLOWED_OPERATOR_RECORD=this.BASE_URL+"/api/v1/user-allowed-operator/"
    this.REMOVE_MANY_ALLOWED_OPERATOR_RECORD=this.BASE_URL+"/api/v1/user-allowed-operator"
    this.ASSIGN_OPERATORS_TO_USER=this.BASE_URL+"/api/v1/user-allowed-operator"

    this.ASSIGN_OPERATORS_TO_GLOBAL_AGENT=this.BASE_URL+"/api/v1/global-agent-allowed-operator"
    this.GET_ALL_ALLOWED_OPERATORS_BY_GLOBAL_AGENT=this.BASE_URL+"/api/v1/global-agent-allowed-operator/user/"
    this.REMOVE_ONE_GLOBAL_ASSIGNED_OPERATOR_RECORD=this.BASE_URL+"/api/v1/global-agent-allowed-operator/"
    this.REMOVE_MANY_GLOBAL_ASSIGNED_OPERATOR_RECORD=this.BASE_URL+"/api/v1/global-agent-allowed-operator"

    this.ASSIGN_AGENTS_TO_MANAGER=this.BASE_URL+"/api/v1/agent-manager-team"
    this.REMOVE_AGENT_FROM_MANAGER=this.BASE_URL+"/api/v1/agent-manager-team/"
    this.GET_ALL_AGENTS_FOR_MANAGER=this.BASE_URL+"/api/v1/agent-manager-team/manager/"
    this.GET_ALL_AGENTS_FOR_MANAGER_BY_STATUS=this.BASE_URL+"/api/v1/manager-agent-allowed-operator"
    this.GET_MANAGER_TEAM_BY_ID=this.BASE_URL+"/api/v1/agent-manager-team/manager/"

    this.LINK_USER_ACCOUNT=this.BASE_URL+"/api/v1/user/link-account/"
    this.LINK_ORGANIZATION_ACCOUNT=this.BASE_URL+"/api/v1/organization/link-account/"

    this.RESET_AGENT_PIN=this.BASE_URL+"/api/v1/user/pos/resetPin/"
  }

  getHeaders = (token) => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        Authorization: "Bearer " + token,
        "DeviceType":"OTHER"
      },
    };
  };

  getMsHeaders = () => {
    return {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": this.ORIGIN,
        Authorization: "Basic online::"+process.env.REACT_APP_TOKEN,
        "DeviceType":"OTHER"
      },
    };
  };

  getBankCodes= () => {
    return [
      {
         "code": "00000","name":"BNR KIGALI"
      },
      {
          "code": "00010","name":"I AND M BANK"
      },
      {
          "code": "00020","name":"AB BANK"
      },
      {
          "code": "00025","name":"Commercial Bank of Africa Rwanda Plc"
      },
      {
          "code": "00040","name":"BK KIGALI"
      },
      {
          "code": "00070","name":"FINABANK KIGALI"
      },
      {
          "code": "00090","name":"UMWALIMU SACCO"
      },
      {
          "code": "00100","name":"ECOBANK KIGALI"
      },
      {
          "code": "00115","name":"ACCESS BANK KIGALI"
      },
      {
          "code": "00130","name":"CGBK CENTRALE"
      },
      {
          "code": "00145","name":"UOB KIGALI"
      },
      {
          "code": "00160","name":"KCB KIGALI"
      },
      {
          "code": "00175","name":"ZIGAMA CREDIT SAVING SCHEME"
      },
      {
          "code": "00192","name":"EQUITY BANK"
      },
      {
          "code": "00208","name":"BANK OF AFRICA RWANDA"
      },
      {
          "code": "00224","name":"UNGUKA"
      },
      {
          "code": "00400","name":"BPR KIGALI"
      }
  ];
  };
}

class FinanceService {
  constructor() {
    this.BASE_URL = getMsUrl('fin');
    this.GET_ALL_AGENTS = this.BASE_URL + "/api/v1/getAgents";
    this.CREATE_AGENT_OUTLET = this.BASE_URL + "/api/v1/createAgentOutlet";
    this.CREATE_AGENT_DEVICE = this.BASE_URL + "/api/v1/createAgentDevice";
    this.GET_AGENT_PROFILE = this.BASE_URL + "/api/v1/getAgentProfile/";
    this.ENABLE_AGENT_DEVICE = this.BASE_URL + "/api/v1/enableAgentDevice/";
    this.DISABLE_AGENT_DEVICE = this.BASE_URL + "​/api/v1/disableAgentDevice/";
    this.GET_AGENT_OUTLETS = this.BASE_URL + "/api/v1/getAgentOutlets/";
    this.GET_AGENT_DEVICES = this.BASE_URL + "/api/v1/getAgentDevices/";

    this.GET_AGENT_BY_TYPE = this.BASE_URL + "/api/v1/getAgentsByType/";

    this.FLOAT_ALLOCATION = this.BASE_URL + "/api/v1/agentFloatAllocation";
  
    this.GET_AGENT_TRANSACTIONS =
      this.BASE_URL + "/api/v1/getAgentTransactions/";
    this.CREATE_GENERIC_COMMISSION =
      this.BASE_URL + "/api/v1/createGenericCommission";
    this.CREATE_CUSTOM_COMMISSION =
      this.BASE_URL + "/api/v1/createCustomCommission";
    this.CREATE_SUBCOMMISSION = this.BASE_URL + "/api/v1/createSubCommission";
    this.ENABLE_COMMISSION = this.BASE_URL + "/api/v1/enableCommission/";
    this.DISABLE_COMMISSION = this.BASE_URL + "/api/v1/disableCommission/";
    this.UPDATE_COMMISSION = this.BASE_URL + "/api/v1/updateCommission/";
    this.GET_COMMISSION_TYPES = this.BASE_URL + "/api/v1/getCommissionTypes";
    this.GET_ALL_COMMISSIONS = this.BASE_URL + "/api/v1/getCommissions";
    this.GET_ALL_SERVICE_FEE_CONFIGURATION = this.BASE_URL + "/api/v1/getServiceFeeConfigurations";
    this.GET_ALL_AGENTS_FOR_SERVICE_FEE = this.BASE_URL + "/api/v1/getAgentsForServiceFee";
    this.GET_COMMISSION_BY_ID = this.BASE_URL + "/api/v1/getCommissionById/";
    this.GET_COMMISSION_BY_ORGANIZATION_ID =
      this.BASE_URL + "/api/v1/getCommissionsByOrganizationId/";
    this.GET_COMMISSION_BY_ORGANIZATION_TYPE =
      this.BASE_URL + "/api/v1/getCommissionsByOrganizationType/";

    this.GET_TRANSACTION_TYPES = this.BASE_URL + "/api/v1/getTransactionTypes";
    this.GET_ALL_TRANSACTIONS = this.BASE_URL + "/api/v1/getTransactions";
    this.GET_ALL_PAYMENT_REQUESTS = this.BASE_URL + "/api/v1/getPaymentRequests";
    this.PAYMENT_REFUND = this.BASE_URL + "/api/v1/refundPayment";

    this.GET_POS_AGENTS = this.BASE_URL +"/api/v1/getPosAgents/";

    this.GET_ACCOUNT_TRANSACTIONS =
      this.BASE_URL + "/api/v1/getAccountTransactions?account_number=";
    this.GET_TRANSACTION_STATUS =
      this.BASE_URL + "/api/v1/getTransactionStatus?id=";
    this.SHOW_TRANSACTION = this.BASE_URL + "/api/v1/showTransaction?id=";
    this.SHOW_ACCOUNT_TRANSACTION =
      this.BASE_URL + "/api/v1/showAccountTransaction?transaction_id=";

    this.GET_ACCOUNT_TYPES = this.BASE_URL + "/api/v1/getAccountTypes";
    this.GET_INTERNAL_ACCOUNTS = this.BASE_URL + "/api/v1/getInternalAccounts";
    this.GET_ALL_ACCOUNTS = this.BASE_URL + "/api/v1/getAccounts";
    this.GET_WALLET_BY_ID = this.BASE_URL + "/api/v1/getWalletBalance/";
    this.GET_WALLET_BY_NID = this.BASE_URL + "/api/v1/getWalletByIdNumber/";
    this.GET_WALLET_BY_PHONE =
      this.BASE_URL + "/api/v1/getWalletByPhoneNumber/";
    this.GET_ACCOUNT_PROFILE = this.BASE_URL + "/api/v1/getAccountProfile/";
    this.GET_ACCOUNT_BALANCE = this.BASE_URL + "/api/v1/getAccountBalance/";
    this.ENABLE_ACCOUNT = this.BASE_URL + "/api/v1/enableAccount/";
    this.DISABLE_ACCOUNT = this.BASE_URL + "/api/v1/disableAccount/";
    this.ENABLE_WALLET = this.BASE_URL + "/api/v1/enableWallet/";
    this.DISABLE_WALLET = this.BASE_URL + "/api/v1/disableWallet/";
    this.AGENT_ACCOUNT_TOPUP = this.BASE_URL + "/api/v1/agentAccountTopup";

    this.GET_ACCOUNT_SERVICE_FEE = this.BASE_URL + "/api/v1/getServiceFeeAccount/";

    this.GET_POS_AGENT = this.BASE_URL + "/api/v1/getPosAgents/";


    this.GET_FINANCIAL_SETTLEMENT_PROCESSES = this.BASE_URL + "/api/v1/getFinancialSettlementProcesses";
    this.GET_FINANCIAL_SETTLEMENT_TRANSACTIONS = this.BASE_URL + "/api/v1/getFinancialSettlementTransactions";

    this.GET_SETTLEMENT_PROCESSES =
      this.BASE_URL + "/api/v1/getSettlementProcesses";
    this.GET_SETTLEMENT_TRANSACTIONS =
      this.BASE_URL + "/api/v1/getSettlementTransactions";
    this.GET_SETTLEMENT_BATCHES =
      this.BASE_URL + "/api/v1/getSettlementBatches";
      this.GET_SETTLEMENT_TRANSFERS =
      this.BASE_URL + "/api/v1/getSettlementTransfers";
      this.CHECK_SETTLEMENT_PROCESS =
      this.BASE_URL + "/api/v1/checkSettlementProcess";
      this.RESEND_SETTLEMENT_TRANSFERS =
      this.BASE_URL + "/api/v1/resendSettlementTransfers";
    this.REVERSE_TRANSACTION = this.BASE_URL + "/api/v1/reverseTransaction";
    this.NEW_CARD_REGISTRATION=this.BASE_URL+"/api/v1/newCardRegistration"
    this.INITIATE_SETTLEMENT_PROCESS=this.BASE_URL+"/api/v1/initiateSettlementProcess"

    this.AGENT_CASH_BACK=this.BASE_URL+"/api/v1/agentFloatCashBack"
    this.AGENT_INITIATE_RECONCILIATION=this.BASE_URL+"/api/v1/initiateAgentReconciliation"

    this.SET_SERVICE_FEE=this.BASE_URL+"/api/v1/setServiceFee"
    this.ENABLE_SERVICE_FEE=this.BASE_URL+"/api/v1/enableServiceFeeConfiguration/"
    this.DISABLE_SERVICE_FEE=this.BASE_URL+"/api/v1/disableServiceFeeConfiguration/"
    this.UPDATE_SERVICE_FEE=this.BASE_URL+"/api/v1/updateServiceFee/"
    this.UPDATE_SERVICE_FEE=this.BASE_URL+"/api/v1/updateServiceFee/"
    this.ACCOUNTS_SERVICE_FEE=this.BASE_URL+"/api/v1/getServiceFeeAccounts"
    this.GET_AGENT_TOPUP_REQUEST = this.BASE_URL + "/api/v1/getTransactionRequests"
    this.CONFIRM_TRANSACTION_REQUEST = this.BASE_URL + "/api/v1/confirmTransactionRequest"
    this.REQUEST_AGENT_TOPUP_TRANSACTION = this.BASE_URL + "/api/v1/requestTransaction"
    this.GET_AGENTS = this.BASE_URL + "/api/v1/getAgents"
    this.REFUND_REQUEST = this.BASE_URL + "/api/v1/requestTransaction"
    this.GET_TRANSACTION_REQUEST = this.BASE_URL + "/api/v1/getTransactionRequests";
    this.GET_SERVICE_FEE_REPORT = this.BASE_URL + "/api/v1/getServiceFeeReport";
    this.GET_BALANCE_REPORT = this.BASE_URL + "/api/v1/getAgentBalanceReport";
    this.GET_TX_SUMMARY_REPORT = this.BASE_URL + "/api/v1/getAgentTxSummaryReport";
    this.ASSIGN_CARD = this.BASE_URL + "/api/v1/assignCard";
    this.INITIATE_SERVICE_FEE_PAYMENT = this.BASE_URL + "/api/v1/initiateServiceFeePayment";
    this.GET_AGENTS_CARD = this.BASE_URL + "/api/v1/getAgentsCard"
    this.VALIDATE_ACCOUNT = this.BASE_URL + "/api/v1/rndps/checkWallet"
    this.EKASH_REGISTRATION = this.BASE_URL + "/api/v1/rndps/walletRegistrationOtp"

    this.COPMPANY_CARD_TRANSACTIONS =
			this.BASE_URL + '/api/v1/companyCardTransactions';
    this.GET_CARD_SUMMARY = this.BASE_URL+"/api/v1/getCardSummary"
    this.COPMPANY_CARD_TRANSACTION = this.BASE_URL+'/api/v1/companyCardTransaction';
  }
}

class TransportService {
  constructor() {
    this.BASE_URL = getMsUrl('tr');
    this.GET_ALL_LOCATIONS =
      this.BASE_URL + "/api/v1/locations/getAllLocations";
    this.GET_LOCATIONS_BY_LEVEL =
      this.BASE_URL + "/api/v1/locations/findLocationsByLevel/3";
    this.GET_ORGANIZATION_BY_ADMIN_ID =
      this.BASE_URL + "/api/v1/integrations/getOrganizationByAdminId/";
    this.GET_STOPS=this.BASE_URL+"/api/quickbus/QuickBusGetStops"
    this.GET_AVAILABLE_SCHEDULES=this.BASE_URL+"/api/quickbus/GetQuickBusSearchedList"
    this.GET_SEAT_STATUS=this.BASE_URL+"/api/quickbus/GetQuickBusSeatManagement"
    this.GET_KIOSQUE_TICKET=this.BASE_URL+"/api/quickbus/GetKioskTicket"
    this.GET_REVENUE_PER_ORGANIZATION = this.BASE_URL + "api/v1/inter-operability-reports/per-organisation"
    this.GET_REVENUE_PER_ROUTE = this.BASE_URL + "/api/v1/inter-operability-reports/per-route"
    this.GET_REVENUE_PER_PLATE_NUMBER = this.BASE_URL + "/api/v1/inter-operability-reports/per-plate-number"
    this.GET_REVENUE_TICKETS = this.BASE_URL + "/api/v1/inter-operability-reports/get-detailed-ac-group-tickets"
  }
}

class ReportingService {
  constructor() {
    this.BASE_URL = getMsUrl('re');
    this.GET_ITEM_TYPES = this.BASE_URL + "/inventory/item-types";
    this.GET_ITEMS = this.BASE_URL + "/inventory/items";
    this.CREATE_ITEM_TYPE = this.BASE_URL + "/inventory/item-type";
    this.CREATE_ITEM = this.BASE_URL + "/inventory/item";
    this.UPLOAD_STOCK = this.BASE_URL + "/inventory/upload-stock";
    this.UPLOAD_CARDS = this.BASE_URL + "/inventory/upload-stock";
    this.CREATE_STOCK = this.BASE_URL + "/inventory/stocks";
    this.GET_ALL_STOCKS = this.BASE_URL + "/inventory/stocks";
    this.GET_STOCK_ITEM = this.BASE_URL + "/inventory/stocks/item";
    this.GET_STOCK_BY_ORGANIZATION = this.BASE_URL + "/inventory/stocks/items";
    this.ADD_STOCK = this.BASE_URL + "/inventory/stocks/add-stock";
    this.NIDA_DOCUMENT = this.BASE_URL + "/nida/document";
    this.SEND_SMS = this.BASE_URL + "/communication/send-sms";
    this.REQUEST_STOCK = this.BASE_URL + "/inventory/stocks/request-stock";
    this.GIVE_STOCK = this.BASE_URL + "/inventory/stocks/give-stock";
    this.SELL_STOCK = this.BASE_URL + "/inventory/stocks/sell-stock";
    this.STOCK_SUPPLY =
      this.BASE_URL + "/inventory/stocks/stock-approvisionement";
    this.STOCK_STATUS = this.BASE_URL + "/inventory/stocks/stock-status";
    this.STOCK_MOVEMENT = this.BASE_URL + "/inventory/stocks/stock-movement";
    this.STOCK_MOVEMENT_ITEM =
      this.BASE_URL + "/inventory/stocks/stock-movement-item";
    this.TRACK_STATUS = this.BASE_URL + "/inventory/stocks/track-stock-status";
    this.ITEM_TRACK = this.BASE_URL + "/inventory/stocks/item-mvt-history";
    this.BATCH_TRACK = this.BASE_URL + "/inventory/stocks/batch-mvt-history";
    this.CONFIRM_EMAIL=this.BASE_URL+"/user/validation-otp"

    ////////////////// new inventory v2 ///////////////////

    this.GET_ITEM_CATEGORIES=this.BASE_URL+"/api/v2/inventory/item-categories/all";
    this.CREATE_ITEM_CATEGORY=this.BASE_URL+"/api/v2/inventory/item-categories";
    this.GET_SUPPLY_ITEM=this.BASE_URL+"/api/v2/inventory/supplies";
    this.SUPPLY_ONE_ITEM=this.BASE_URL+"/api/v2/inventory/supplies/one-item";
    this.SUPPLY_MULTIPLE_ITEMS=this.BASE_URL+"/api/v2/inventory/supplies/items-in-batch";
    this.SUPPLY_MULTIPLE_CARDS=this.BASE_URL+"/api/v2/inventory/supplies/cards-in-batch";
    this.GET_ALL_CUSTOMERS=this.BASE_URL+"/api/v2/inventory/customers";
    this.RECORD_CUSTOMER=this.BASE_URL+"/api/v2/inventory/customers/commuter";
    this.GET_ALL_ITEMS=this.BASE_URL+"/api/v2/inventory/items";
    this.UPDATE_ITEM=this.BASE_URL+"/api/v2/inventory/items/";
    this.GET_ITEM_CATEGORY=this.BASE_URL+"/api/v2/inventory/items/by/item-category/";
    this.REQUEST_ITEM=this.BASE_URL+"/api/v2/inventory/request/item";
    this.GET_CUSTOMER_BY_TYPE=this.BASE_URL+"/api/v2/inventory/customers/by-type/";
    this.GET_PENDING_REQUEST=this.BASE_URL+"/api/v2/inventory/request/pending?sort=desc";
    this.SALE_ITEM=this.BASE_URL+"/api/v2/inventory/sales";
    this.GET_SALES=this.BASE_URL+"/api/v2/inventory/sales";
    this.RENT_ITEM=this.BASE_URL+"/api/v2/inventory/stock-movement/rent-item";
    this.GET_RENTED_ITEM=this.BASE_URL+"/api/v2/inventory/stock-movement/rented";
    this.RETURN_ITEM=this.BASE_URL+"/api/v2/inventory/stock-movement/return-item";

    ///////////////////      Admin reports ///////////////////////////

    this.GENERAL_CHANNEL_PERFORMANCE =
      this.BASE_URL + "/traffic-report/general-channel-performance";
    this.SINGLE_CHANNEL_PERFORMANCE =
      this.BASE_URL + "/traffic-report/single-channel-performance";
    this.GENERAL_ROUTE_PERFORMANCE =
      this.BASE_URL + "/traffic-report/genaral-routes-performance";
    this.SINGLE_ROUTE_PERFORMANCE =
      this.BASE_URL + "/traffic-report/single-route-performance";
    this.GENERAL_OPERATOR_PERFORMANCE =
      this.BASE_URL + "/traffic-report/general-operators-performance";
    this.GENERAL_AGENT_PERFORMANCE =
      this.BASE_URL + "/traffic-report/general-agents-transactions";
  }
}

class Validator {
  validEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  validUsername(u) {
    const re = /^[a-z\d]{5,20}$/i;

    return re.test(String(u).toLowerCase());
  }

  validUrl(u) {
    const re = /^https?\:\/\/[^\/\s]+(\/.*)?$/;

    return re.test(String(u).toLowerCase());
  }

  difference(a1, a2) {
    //console.log(a1.length, a2.length);
    return a1.filter(({ role_privilege_id: id1 }) =>
      a2.some(({ role_privilege_id: id2 }) => id2 != id1)
    );
  }

  tooShort(s) {
    return s.length < 3;
  }

  formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(
        (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
      ).toString();
      let j = i.length > 3 ? i.length % 3 : 0;

      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
            Math.abs(amount - i)
              .toFixed(decimalCount)
              .slice(2)
          : "")
      );
    } catch (e) {
      console.log(e);
    }
  }

  // formatNumber(num) {
  //   if (num >= 1000000000) {
  //     return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  //   }
  //   if (num >= 1000000) {
  //     return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  //   }
  //   if (num >= 1000) {
  //     return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  //   }
  //   return num;
  // }

  formatNumber(number) {
    const SI_POSTFIXES = ["", "k", "M", "G", "T", "P", "E"];
    const sign = number < 0 ? '-1' : '';
    const absNumber = Math.abs(number);
    const tier = Math.log10(absNumber) / 3 | 0;
    // if zero, we don't need a prefix
    if(tier == 0) return `${absNumber}`;
    // get postfix and determine scale
    const postfix = SI_POSTFIXES[tier];
    const scale = Math.pow(10, tier * 3);
    // scale the number
    const scaled = absNumber / scale;
    const floored = Math.floor(scaled * 10) / 10;
    // format number and add postfix as suffix
    let str = floored.toFixed(1);
    // remove '.0' case
    str = (/\.0$/.test(str)) ? str.substr(0, str.length - 2) : str;
    return `${sign}${str}${postfix}`;
}

  groupArrayOfObjects(list, key) {
    return list.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  sum(items, prop) {
    return items.reduce(function (a, b) {
      return parseInt(a) + parseInt(b[prop]);
    }, 0);
  }

  parsePagination=(link)=>{
  
    var out={}
    
    if(link===undefined){
      return null
    }
    link.split(",").map((l)=>{
      var l=l.trim()
    
      var parts=l.split(";")
      var url=parts[0]
      var rel=parts[1]
     
      //get url params
      var params=new URLSearchParams(url)
      var n=params.get("page")
      var x=rel.split("=")[1]
    
    //replace all ' from x
    x=x.replace(/'/g,"")
    //retsrieve number from n
    var num=n.replace(/[^0-9]/g,"")
    
      if(x=="next"){
      out["next"]=num;
      }
      
      if(x=="last"){
        out["last"]=num
      }
     
    })
     return out;
    }

  getTransactionIcon(trans,paint){
    switch(trans){
      case "TICKET PAYMENT":
        return <ConfirmationNumber fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
      case "CARD TOPUP":
        return <CreditCard fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
      case "CUSTOMER ACCOUNT TOPUP":
        return <AccountBalanceWallet fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "AGENT ACCOUNT TOPUP":
        return <AccountBalanceWallet fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "POS PAYMENT":
        return <Contactless fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "ONLINE PAYMENT":
        return <Dvr fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "ATM WITHDRAW":
        return <Atm fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "AGENT ASSISTANT FLOAT ALLOCATION":
        return <TrendingDown fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "ACCOUNT TO ACCOUNT TRANSFER":
        return <CompareArrows fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "OPERATOR PAYMENT REQUEST":
        return <ConfirmationNumber fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
        case "TRANSACTION REVERSAL":
          return <RotateLeft fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
          case "PERSON":
          return <Group fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
      default:
        return <AcUnit fontSize={paint?'large':'default'} color={paint?'primary':'inherit'}/>
      
    }
  }
}

function p(){
  return window.location.protocol==='https:'
}
const hasPermission = (perm) => {
  var data = new AdminService().accountData;
  if (data.permissions == null) {
    return false;
  } else if (perm == "GRANTED") {
    return true;
  } else {
    var perms = data.permissions;
    return perms.filter((obj) => obj.name == perm).length != 0;
  }
};

function Permissions(props) {
  const { permissions } = props;

  //compare if permission match here
  var match = hasPermission(permissions);

  return <>{match ? props.children : <></>}</>;
}

const getMsUrl=(ms)=>{
  switch(ms){
    case 'ad':
      return p()?process.env.REACT_APP_ADMIN_URL_SECURE:process.env.REACT_APP_ADMIN_URL
    case 'fin':
      return p()?process.env.REACT_APP_FINANCE_URL_SECURE:process.env.REACT_APP_FINANCE_URL
    case 'tr':
      return p()?process.env.REACT_APP_TRANSPORT_URL_SECURE:process.env.REACT_APP_TRANSPORT_URL
    case 're':
      return p()?process.env.REACT_APP_REPORTING_URL_SECURE:process.env.REACT_APP_REPORTING_URL
    case 'wz':
      return p()?process.env.WIZANALYTICS_BASEURL:process.env.WIZANALYTICS_BASEURL
    default:
      return "Unknown url"

  }
}


export {
  AdminService,
  FinanceService,
  TransportService,
  ReportingService,
  Validator,
  Permissions,
  hasPermission,
  getMsUrl
};
